












import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {Chart} from 'highcharts-vue'
import axios from 'axios';
import * as Highcharts from "highcharts";
import {Point, XAxisOptions} from "highcharts";
import {currency} from "@/util/formatter";

@Component({
    components: {highcharts: Chart}
})
export default class StackedChart extends Vue {

    @Prop()
    dataEndpoint!: string;

    @Prop({
        default: 'vertical'
    })
    chartType!: 'vertical' | 'horizontal';

    @Prop()
    xAxisTitle!: string;

    @Prop()
    yAxisTitle!: string;

    private readonly updateArgs = [true, true, true];

    private isLoading = false;
    private error: string | null = null;

    private chartOptions: Highcharts.Options = {
        xAxis: {
            categories: [],
            title: {
                text: this.xAxisTitle
            },
        },
        yAxis: {
            title: {
                text: this.yAxisTitle
            },
            stackLabels: {
                verticalAlign: this.chartType === 'vertical' ? 'top' : 'middle',
                overflow: "allow",
                crop: false,
                align: this.chartType === 'vertical' ? 'center' : 'right',
                allowOverlap: true,
                enabled: true
            }
        },
        chart: {
            type: this.chartType === 'vertical' ? 'column' : 'bar',
            styledMode: true,
            numberFormatter: (number: number) => {
                return currency(number);
            },
            spacingTop: 25,
            spacingBottom: 25,
        },
        exporting: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        series: [],
        navigation: {
            buttonOptions: {
                enabled: false
            }
        },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            valueDecimals: 2,
            pointFormatter: function() {
                const formatted = currency(this.y!);
                const formattedTotal = currency(this.total!);
                return `${this.series.name}: <b>${formatted}</b><br/>Total: ${formattedTotal}`;
            },
        }
    };

    private mounted() {
        this.loadData()
    }

    @Watch('dataEndpoint')
    private onDataEndpointChanged() {
        this.loadData();
    }

    private loadData() {
        this.chartOptions.series = [];
        this.isLoading = true;
        this.error = null;

        axios.get(this.dataEndpoint)
            .then(result => {
                const data = result.data;

                (this.chartOptions.xAxis as XAxisOptions).categories = data.categories;
                const chartData = data.chartData;
                for (let [name, data] of Object.entries(chartData)) {
                    this.chartOptions.series?.push(
                        <Highcharts.SeriesOptionsType> {
                            stacking: 'normal',
                            type: this.chartType === 'vertical' ? 'column' : 'bar',
                            name,
                            data
                        }
                    )
                }
            })
            .catch(error => {
                const data = error.response.data;
                this.error = data.message || 'Could not load data for this report.';
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}
